import { styled } from 'styled-components';

import { colors, spacing, transition } from 'theme/theme';

export const TagHolder = styled.span`
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  transition: background ${transition};

  &[data-variant='default'] {
    border: 1px solid ${colors.elementGrey};
  }

  &[data-variant='danger'] {
    background: ${colors.lightRed};
    color: ${colors.alertRed};
  }

  &[data-variant='primary'] {
    background: ${colors.brandBlue};
    color: ${colors.white};
  }

  &[data-size='micro'] {
    gap: 2px;
    border-radius: 4px;
    padding: 2px 5px;
  }

  &[data-size='small'] {
    gap: ${spacing[4]};
    border-radius: 4px;
    padding: ${spacing[4]} ${spacing[8]};
  }

  &[data-size='large'] {
    gap: ${spacing[8]};
    border-radius: 8px;
    padding: ${spacing[8]} ${spacing[16]};
  }
`;

export const TagPrefixHolder = styled.span`
  display: flex;

  &:empty {
    display: none;
  }
`;

export const TagText = styled.span`
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
`;
